import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class FairEvaluationsAnalytics extends AnalyticsBase {
  public readonly namespace = 'FairEvaluations';
  public readonly requireViewContext = true;

  public trackChangeCompanySettings(enabled: boolean): void {
    this.track('ChangeCompanySettings', { mode: enabled ? 'display' : 'turnOFF' });
  }
}
